import type { ReactNode } from "react";
import sunfishLogo from "~assets/img/sunfish-logo.svg";

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-8 bg-sidebar">
      <div className="mb-8">
        <div className="flex h-[50] w-auto items-center justify-center">
          <img
            src={sunfishLogo}
            alt="Sunfish Events"
            width={340}
            height={50}
            className="opacity-80"
          />
        </div>
      </div>
      {children}
    </div>
  );
}
